import React, { useEffect } from "react";
import { ReactSVG } from "react-svg";
import { formatNumber } from "src/utils/helper/functions";

type LiabilitiesProps = {
  liabilitiesData: any;
  showAssetsDetails: (keyName: string) => void;
  setSelectedCashItem: any;
  setSelectedCashItemCurrency: any;
  selectedAccount: any;
};

const LiabilitiesComponent: React.FC<LiabilitiesProps> = ({
  liabilitiesData,
  showAssetsDetails,
  setSelectedCashItem,
  setSelectedCashItemCurrency,
  selectedAccount,
}: LiabilitiesProps) => {
  const [data, setData] = React.useState<any[]>([]);

  useEffect(() => {
    setData(liabilitiesData);
  }, [liabilitiesData]);

  const getGroupByData = (data: any[]): any => {
    const groupedData = data.reduce((acc: any, obj: any) => {
      const key = obj.productGroupCode;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});

    if (groupedData?.CSH) {
      return {
        CSH: groupedData.CSH,
        ...groupedData,
      };
    } else {
      return groupedData;
    }
  };

  const getSumission = (data: any[]): number => {
    return data?.reduce(
      (accumulator, currentValue) =>
        accumulator + currentValue.reportingMarketAmount,
      0
    );
  };

  const onItemClicked = (item: any): void => {
    showAssetsDetails(getGroupByData(data)[item][0]?.productGroupCode);
    setSelectedCashItem(null);
    setSelectedCashItemCurrency(null);
  };

  const scrollToDiv = (key: string) => {
    const element = document.getElementById(key);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div className="mt-3 p-3 md:p-4 bg-white rounded-xl add-shadow flex-col justify-start items-center gap-3 inline-flex slide-right">
      <div className="Frame576281 self-stretch  flex-col justify-start items-center gap-3 flex">
        <div className="Frame576049 self-stretch  flex-col justify-start items-start gap-5 flex">
          <div className="Frame576293 self-stretch justify-start items-center gap-4 inline-flex">
            <div className="Assets grow shrink basis-0 opacity-90 text-[#2a2a2a] text-sm md:text-base font-bold">
              Liabilities
            </div>
            <div className=" justify-start items-center gap-3 flex">
              <div className=" w-[13.33px] h-[13.33px] relative opacity-50">
                <div className=" w-[13.33px] h-[13.33px] left-0 top-0 absolute"></div>
              </div>
              <div className=" w-[13.33px] h-[13.33px] justify-center items-center flex">
                <div className=" w-[13.33px] h-[13.33px] relative"></div>
              </div>
            </div>
          </div>
          <div className="Frame576292 self-stretch  flex-col justify-start items-start gap-3 flex">
            <div className="Frame576304 self-stretch  flex-col justify-start items-start gap-3 flex">
              {Object.keys(getGroupByData(data))?.map(
                (item: any, index: number) => (
                  <div
                    key={item?.id}
                    className="cursor-pointer self-stretch p-4 bg-[#fdfdfd] rounded-xl shadow border border-[#ececec] justify-start items-center gap-4 inline-flex"
                    onClick={() => {
                      onItemClicked(item);
                      scrollToDiv(
                        getGroupByData(data)[
                          item
                        ][0]?.productGroupCode?.toLowerCase()
                      );
                    }}
                  >
                    <div className="Frame576190 grow shrink basis-0 flex-col justify-center items-start gap-4 inline-flex">
                      <div className="Frame576191 self-stretch justify-between items-center inline-flex">
                        <div className="Frame576301 justify-start items-center gap-2 flex">
                          <div className="Money41 w-[30px] h-[30px] relative">
                            <ReactSVG
                              className="svg-image"
                              src={
                                getGroupByData(data)[item][0]?.icon ||
                                "/images/cash-icon.svg" ||
                                "/images/loan-icon.svg"
                              }
                            />
                          </div>
                          <div className="Frame6559 flex-col justify-start items-start gap-0.5 inline-flex">
                            <div className="Frame6539 self-stretch justify-start items-center gap-1 inline-flex">
                              <div className="Label text-[#2a2a2a] text-xs md:text-sm font-semibold leading-snug tracking-tight">
                                {getGroupByData(data)[item][0]
                                  ?.productGroupCode === "CSH"
                                  ? "Cash Payable"
                                  : getGroupByData(data)[item][0]
                                      ?.productGroupName}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="Frame576310 justify-end items-center gap-2 flex">
                          <div className="Label text-[#2a2a2a] text-sm md:text-base font-semibold leading-relaxed tracking-tight">
                            {formatNumber(
                              getSumission(getGroupByData(data)[item]),
                              selectedAccount?.reportingCurrencyDcp,
                              false
                            )}
                          </div>
                          <div className=" w-6 h-6 justify-center items-center flex">
                            <img
                              src="/images/arrow-right.svg"
                              width={24}
                              height={24}
                              alt="arrow"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiabilitiesComponent;
